import React from 'react'
import Modal from 'react-modal'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom'

Modal.setAppElement('#root')

export const SuccessModal = ({ isOpen, setIsOpen }) => {
  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(47, 128, 237, 0.5)',
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      zIndex: 9,
      overflowY: 'auto',
    },
    content: {
      position: 'absolute',
      backgroundColor: '#FFFFFF',
      borderRadius: '10px',
      height: 'fit-content',
      margin: '10px auto',
      maxWidth: '540px',
      width: '95%',
      outlineWidth: 0,
    },
  }
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {
        setIsOpen(false)
      }}
      overlayClassName={'modal_overlay'}
      className={'modal'}
      style={customStyles}
      contentLabel="Благодарим Вас за прохождения опроса!"
      shouldCloseOnOverlayClick={true}
    >
      <div className="modal__phone">
        <h2 className="modal__title">
        {t('successModalTitle')}
        </h2>
        <br />
        <div className="modal__wrap">
          <div className="modal__subtitle">
          {t('successModalText')}
          </div>
          <br />
          <div className="authorization__input-group buttons">
            <div></div>
            <div className="authorization__input-button">
              <button
                className="btn btn-red authorization__btn-submit button"
                onClick={() => {
                  setIsOpen(false)
                  history.push('/profile')
                }}
              >
                <span>OK</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
